import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useCMSSettings } from '../hooks/useCMSSettings';

export const InjectIntegrations = () => {
  const { integrations, settings } = useCMSSettings();
  const consentGiven = localStorage.getItem('cookie_consent') === 'true';

  // If cookie banner is enabled but consent isn't given, don't load tracking scripts
  // unless we decide some are strictly necessary. We'll err on the side of caution.
  if (settings?.cookie_banner_enabled === 'true' && !consentGiven) {
    return null;
  }

  const gtm = integrations?.gtm;
  const ga4 = integrations?.ga4;
  const fbPixel = integrations?.facebook_pixel;
  const linkedin = integrations?.linkedin;
  const customScripts = integrations?.custom_scripts;

  return (
    <Helmet>
      {/* GTM Head */}
      {gtm?.is_enabled && gtm.config?.container_id && (
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtm.config.container_id}');
          `}
        </script>
      )}

      {/* GA4 */}
      {ga4?.is_enabled && ga4.config?.measurement_id && (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4.config.measurement_id}`} />
      )}
      {ga4?.is_enabled && ga4.config?.measurement_id && (
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${ga4.config.measurement_id}');
          `}
        </script>
      )}

      {/* Facebook Pixel */}
      {fbPixel?.is_enabled && fbPixel.config?.pixel_id && (
        <script>
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${fbPixel.config.pixel_id}');
            fbq('track', 'PageView');
          `}
        </script>
      )}

      {/* LinkedIn */}
      {linkedin?.is_enabled && linkedin.config?.partner_id && (
        <script type="text/javascript">
          {`
            _linkedin_partner_id = "${linkedin.config.partner_id}";
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(_linkedin_partner_id);
            (function(l) {
            if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
            window.lintrk.q=[]}
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);})(window.lintrk);
          `}
        </script>
      )}

      {/* Custom Header Scripts */}
      {customScripts?.is_enabled && customScripts.config?.head && (
        <script type="text/javascript">{customScripts.config.head}</script>
      )}
    </Helmet>
  );
};
